<template>
  <router-view></router-view>
</template>

<style lang="scss">
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~socicon/css/socicon.css";
@import "~@fortawesome/fontawesome-free/css/all.css";
@import "~line-awesome/dist/line-awesome/css/line-awesome.css";
@import "assets/plugins/flaticon/flaticon.css";
@import "assets/plugins/flaticon2/flaticon.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
@import "assets/css/dashbord-style.css";
</style>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
// import { NOTIFICATION_COUNT } from "@/core/services/store/auth.module";
export default {
  name: "App",
  watch: {
    // $route(to, from) {
    //   this.getUnreadNotificationCount();
    // },
  },
  methods: {
    // getUnreadNotificationCount() {
    //   if (this.isAuthenticated) {
    //     let data = {
    //       id: this.currentUser.id,
    //     };
    //     frontendAPI.getUnreadNotificationCount(data).then((response) => {
    //       this.$store.dispatch(NOTIFICATION_COUNT, { count: response.count });
    //     });
    //   }
    // },
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"]),
  },
};
</script>
